import { svg } from 'lit';
import { KeyScale } from '../../axis/key/KeyScale.js';
import { ValueScale } from '../../axis/value/ValueScale.js';
import { toCurvedSegments, toLinearSegments } from '../segments.js';
import { repeat } from 'lit/directives/repeat.js';
import { segment } from '../types.js';
import { AreaRenderGroup } from './types.js';
import { getBoundary } from '../getBoundary.js';
import { LinearArea } from './fragments/LinearArea.js';
import { CurvedArea } from './fragments/CurvedArea.js';
import { DataPoint } from '../fragments/DataPoint.js';
import { highlightStateProvider } from '../../types.js';
export function Area({
  keyScale,
  valueScale,
  group,
  animate,
  highlightStateProvider
}: {
  keyScale: KeyScale;
  valueScale: ValueScale;
  group: AreaRenderGroup;
  animate: boolean;
  highlightStateProvider: highlightStateProvider;
}) {
  const segments: segment[] = group.curved ? toCurvedSegments(keyScale, valueScale, group.line) : toLinearSegments(keyScale, valueScale, group.line);
  const boundary = getBoundary(keyScale, valueScale);
  const domainPosition = valueScale.domainPosition;
  return svg`
    <g transform="translate(0, 0)" fill="none" class="series-area">
      ${repeat(segments, segment => segment.key, segment => segment.type === 'linear' ? LinearArea({
    segment,
    group,
    boundary,
    domainPosition,
    animate,
    highlightStateProvider
  }) : CurvedArea({
    segment,
    group,
    boundary,
    domainPosition,
    animate,
    highlightStateProvider
  }))}
      ${repeat(group.line, dp => dp.key, dp => DataPoint({
    keyScale,
    valueScale,
    dp,
    group,
    boundary,
    animate,
    highlightStateProvider
  }))}
    </g>
  `;
}